<template>
  <div id="app">
    <b-container fluid>
      <RouterView />
    </b-container>
  </div>
</template>

<script setup>
import { Logger } from "@/logger/logger";
import { RouterView } from 'vue-router'

const log = new Logger("App");
log.debug("App.vue startet ...");
</script>

<style>
.container-fluid {
  max-width: 1170px;
  padding-bottom: 1px;
}
</style>
